import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { EmptyContainer, IconContainer } from './SendToWalletPage.style.js';
export const EmptyListIndicator = ({ icon, children, }) => (_jsxs(EmptyContainer, { children: [_jsx(IconContainer, { children: icon }), _jsx(Typography, { sx: {
                fontSize: 14,
                fontWeight: 700,
                color: 'text.secondary',
            }, children: children })] }));
//# sourceMappingURL=EmptyListIndicator.js.map